import {
  CasBaseDialog,
  CasDisplayField,
  CasRenderDateTime,
  CasTable,
} from 'src/compass/shared/components';
import CasLink from 'src/compass/shared/components/CasLink/CasLink';
import useExportExcelMutation from 'src/compass/shared/hooks/reactQuery/useExportExcelMutation';

interface BatchHistoryDialogProps {
  userName: string;
  onClose: VoidFunction;
}

export default function BatchHistoryDialog({ userName, onClose }: BatchHistoryDialogProps) {
  const { mutate } = useExportExcelMutation({ entity: 'Sce/Claims/AttachBatch' });

  return (
    <CasBaseDialog open maxWidth="lg" onClose={onClose} title="Batch History" showCloseIcon>
      <CasDisplayField label="User" value={userName} />

      <CasTable
        entity="Sce/Claims/AttachBatch"
        defaultOrder="desc"
        columnsSortable={false}
        includeExport={false}
        columns={[
          { field: 'batch', render: CasRenderDateTime },
          { field: 'count' },
          {
            render: ({ row }) => (
              <CasLink onClick={() => mutate({ id: row.batch })}>export</CasLink>
            ),
          },
        ]}
      />
    </CasBaseDialog>
  );
}
